define('Swissup_Orderattachment/js/order-attachment',[
    'jquery',
    'underscore',
    'mage/translate',
    'Magento_Ui/js/modal/modal' // 2.3.3: create 'jquery-ui-modules/widget' dependency
], function ($, _, $t) {
    'use strict';

    $.widget('swissup.orderAttachment', {
        component: 'Swissup_Orderattachment/js/order-attachment',
        options: {
            invalidExtError: $t('Allowed file types: %1'),
            invalidSizeError: $t('Max file size to upload %1M'),
            invalidLimitError: $t('You have reached the limit of files'),
            commentPlaceholder: $t('Comment'),
            removeItem: $t('Delete'),
            downloadItem: $t('Download')
        },
        files: {},

        _create: function () {
            this._super();
            this.prepareObservers();
            this.addUploadedItems();
        },

        addUploadedItems: function () {
            var attachments = this.options.attachments,
                self = this;

            if (attachments) {
                $('#sales_order_view_tabs_swissup_attachments span:first-child').append(
                    `<span class="count">${attachments.length}</span>`
                );

                $.each(attachments, function (index, attachment) {
                    var uniq = Math.random().toString(32).slice(2);

                    self.files[uniq] = attachment.path;
                    self.addAttachmentMarkup(uniq, attachment.path);
                    self.addAttachmentContent(uniq, attachment);
                });
            }
        },

        addAttachmentMarkup: function (pos, fileName) {
            $('.attachment-container').prepend(
                `<div class="swissup-attachment-row" rel="${pos}">
                    <div class="swissup-attachment-loader"></div>
                    <div class="swissup-attachment-row-content">
                        <div class="order-attachment-preview">
                            <div class="attachment-file">
                                <div class="filename">${_.escape(fileName)}</div>
                            </div>
                        </div>
                        <div class="order-attachment-content"></div>
                    </div>
                </div>`
            );
        },

        addAttachmentContent: function (pos, attachment) {
            var self = this,
                row = $('div.swissup-attachment-row[rel="' + pos + '"]'),
                content = row.find('.order-attachment-content'),
                preview = row.find('.order-attachment-preview'),
                attachId = attachment.attachment_id;

            this.previewFile(preview, attachment.type, attachment.preview);

            $(content).append(
                `<textarea class="comment admin__control-textarea" rows="4"
                    ${this.options.letCustomerEditNote ? '' : 'disabled'}
                    id="attachment-comment${attachId}"
                    name="attachment[${attachId}][comment]"
                    placeholder="${_.escape(this.options.commentPlaceholder)}"
                >${_.escape(attachment.comment)}</textarea>
                <div>
                    <a class="swissup-attachment-download" data-turbolinks="false" data-turbo="false"
                        href="${attachment.download}">${_.escape(this.options.downloadItem)}</a>
                    <a class="swissup-attachment-remove" href="#"
                        ${this.options.letCustomerRemoveFile ? '' : 'style="display: none"'}
                        id="swissup-attachment-remove${attachId}">${_.escape(this.options.removeItem)}</a>
                </div>
                <input type="hidden" name="attachment-id"
                    class="swissup-attachment-id${attachId}"
                    value="${attachId}">
                <input type="hidden" name="attachment-hash"
                    class="swissup-attachment-hash${attachId}"
                    value="${attachment.hash}">`
            );

            $('#attachment-comment' + attachId).on('input', _.debounce(function () {
                self.updateComment(attachId, attachment.hash, $(this).val(), pos);
            }, 300));

            $('#swissup-attachment-remove' + attachId).on('click', function (event) {
                event.preventDefault();
                self.removeFile(attachId, attachment.hash, pos);
            });
        },

        showRowLoader: function (row) {
            row.data('attachmentTimer', setTimeout(() => row.addClass('loading'), 200));
        },

        hideRowLoader: function (row) {
            clearTimeout(row.data('attachmentTimer'));
            row.removeClass('loading');
        },

        prepareObservers: function () {
            var self = this;

            $(document).on('dragenter dragover drop', function (event) {
                event.preventDefault();
            });

            $('.swissup-attachment-drag-area')
                .on('dragenter dragover drop dragleave', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                })
                .on('drop', function (event) {
                    Array.from(event.originalEvent.dataTransfer.files).map(self.processingFile);
                });

            $('.swissup-attachment-drag-area').on('click', function () {
                $('#order-attachment').trigger('click');
            });

            $('#order-attachment').on('change', function () {
                Array.from(this.files).map(file => self.processingFile(file));
            });
        },

        processingFile: function (file) {
            var error = this.validateFile(file),
                filesLen = Object.keys(this.files).length,
                uniq = Math.random().toString(32).slice(2);

            if (error) {
                return this.addError(error);
            }

            if (filesLen >= this.options.limit) {
                return this.addError(this.options.invalidLimitError);
            }

            this.files[uniq] = file.name;
            this.addAttachmentMarkup(uniq, file.name);
            this.upload(file, uniq);
        },

        upload: function (file, pos) {
            var self = this,
                form = new FormData(),
                row = $('div.swissup-attachment-row[rel="' + pos + '"]');

            form.append($('#order-attachment').attr('name'), file);

            this.ajax(row, {
                url: this.options.uploadUrl,
                contentType: false,
                processData: false,
                data: form,
                success: function (result) {
                    if (result.success) {
                        self.addAttachmentContent(pos, result);
                    } else {
                        $('div.swissup-attachment-row[rel="' + pos + '"]').remove();
                    }
                },
                error: function () {
                    delete self.files[pos];
                    $('div.swissup-attachment-row[rel="' + pos + '"]').remove();
                }
            });
        },

        updateComment: function (id, hash, comment, pos) {
            this.ajax($('div.swissup-attachment-row[rel="' + pos + '"]'), {
                url: this.options.updateUrl,
                data: {
                    'attachment': id,
                    'hash': hash,
                    'comment': comment
                }
            });
        },

        removeFile: function (id, hash, pos) {
            var self = this,
                row = $('div.swissup-attachment-row[rel="' + pos + '"]');

            this.ajax(row, {
                url: this.options.removeUrl,
                data: {
                    'attachment': id,
                    'hash': hash
                },
                success: function (result) {
                    if (!result.success) {
                        return;
                    }

                    delete self.files[pos];
                    row.fadeOut('500', function () {
                        $(this).remove();
                    });
                }
            });
        },

        ajax: function (row, options) {
            var self = this,
                success = options.success,
                error = options.error,
                data = options.data;

            this.showRowLoader(row);

            if (window.FORM_KEY) {
                if (data instanceof FormData) {
                    data.append('form_key', window.FORM_KEY);
                } else {
                    data = $.extend(data, {
                        form_key: window.FORM_KEY
                    });
                }
            }

            $.ajax($.extend({
                type: 'post',
                global: false,
                data: data,
                success: function (result) {
                    if (!result.success && result.error) {
                        self.addError(result.error);
                    }

                    self.hideRowLoader(row);

                    if (success) {
                        success(result);
                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    self.addError(thrownError);
                    self.hideRowLoader(row);

                    if (error) {
                        error();
                    }
                }
            }, _.omit(options || {}, ['data', 'success', 'error'])));
        },

        previewFile: function (container, attachType, fileUrl) {
            var preview,
                mapping = {
                    image: () => $(`<img class="thumbnail" src="${fileUrl}">`),
                    video: () => $(`<video src="${fileUrl}" width="100%" controls></video>`),
                    audio: () => $(`<audio src="${fileUrl}" style="display:block; width:100%;" controls></audio>`),
                    default: () => $('<div class="swissup-attachment-default-preview"></div>')
                };

            preview = mapping[attachType.split('/')[0]];
            if (!preview) {
                preview = mapping.default;
            }

            preview().insertBefore(container.find('.attachment-file'));
        },

        validateFile: function (file) {
            if (!this.checkFileExtension(file)) {
                return this.options.invalidExtError.replace('%1', this.options.ext.replace(/,/g, ', '));
            }

            if (!this.checkFileSize(file)) {
                return this.options.invalidSizeError.replace('%1', (this.options.size / 1024).toFixed(1));
            }
        },

        checkFileExtension: function (file) {
            var fileExt = file.name.split('.').pop().toLowerCase(),
                allowedExt = this.options.ext.split(',');

            return allowedExt.includes(fileExt);
        },

        checkFileSize: function (file) {
            return file.size / 1024 <= this.options.size;
        },

        addError: function (error) {
            $('.attachment-container').before(
                `<div class="message error message-error swissup-attachment-error">
                    <div>${error}</div>
                </div>`
            );

            $('.swissup-attachment-error').on('click', function () {
                $(this).remove();
            });
        }
    });

    return $.swissup.orderAttachment;
});

